<button
  [disabled]="disabled() ? 'disabled' : null"
  [style.background-color]="color() ? color() : null"
  [class]="getClasses()"
  [ngClass]="{ 'small-responsive-allways': smallResponsiveAllways() }"
  [class.small-responsive]="smallResponsive()"
>
  @if (icon()) {
    <cue-icon [icon]="icon()" />
  }
  <p>
    <ng-content />
  </p>
</button>
